import React from 'react'
import styles from './index.module.scss'

import useOrderType from '../../store/useOrderType'

const ORDER_TYPE_CONF = [
  {
    label: '移动服务单',
    value: 'mobile',
  },
  {
    label: '远程服务单',
    value: 'remote',
  },
]

export default function OrderType() {
  const { orderType, updateOrderType } = useOrderType()

  const handleSelect = (item) => {
    updateOrderType(item.value)
  }

  return (
    <div className={styles.orderTypeSwitch}>
      {ORDER_TYPE_CONF.map((item) => {
        return (
          <div
            className={[
              styles.switchItem,
              orderType.default === item.value ? styles.selected : '',
            ].join(' ')}
            onClick={() => handleSelect(item)}
            key={item.value}
          >
            {item.label}
          </div>
        )
      })}
    </div>
  )
}
